import { svgIconAssets } from "@/assets";

export default {
  name: "SVGIcon",
  functional: true,
  render: function(h, context) {
    const iconName = context.props.name;
    const svgIcon = svgIconAssets[iconName];

    if (context.data.class) {
      context.data.class["svg-icon"] = true;
      context.data.class[`svg-icon-${iconName}`] = true;
      context.data.class["v-icon--is-component"] = false;
    }

    return h(
      {
        template: svgIcon
      },
      context.data,
      context.children
    );
  }
};
